import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import PlayLogsTable from '../PlayLogsTable'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import type { components } from '@/schema'
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { parseAsString, useQueryState } from 'nuqs'

type AdminPlayLogItem = components['schemas']['AdminPlayLogItemResponse']

interface PlayLogsListingProps {
	data: AdminPlayLogItem[]
	total: number
	isLoading?: boolean
	providerOptions: Array<{ value: string; label: string }>
}

export default function PlayLogsListing({
	data,
	total,
	isLoading,
	providerOptions,
}: PlayLogsListingProps) {
	const [providerName, setProviderName] = useQueryState(
		'providerName',
		parseAsString.withOptions({ shallow: false }).withDefault(''),
	)

	const allProviderOptions = [
		{ label: 'ทั้งหมด', value: '' },
		...providerOptions,
	]

	return (
		<div className="space-y-4">
			<div className="flex justify-between">
				<Heading
					title="ประวัติการเล่น"
					description="ประวัติการเล่นของผู้เล่นทั้งหมด"
				/>

				<div className="flex flex-col items-end gap-4">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			<div className="flex flex-wrap items-center gap-2">
				<DataTableSearch placeHolder="ค้นหาเบอร์โทร..." />
				<Select
					value={providerName}
					onValueChange={(value) => setProviderName(value)}
				>
					<SelectTrigger className="w-full sm:w-48">
						<SelectValue placeholder="เลือกผู้ให้บริการ" />
					</SelectTrigger>
					<SelectContent>
						<SelectGroup>
							{allProviderOptions.map((option) => (
								<SelectItem key={option.value} value={option.value}>
									{option.label}
								</SelectItem>
							))}
						</SelectGroup>
					</SelectContent>
				</Select>
				<DataTableResetFilter />
			</div>

			<Separator />
			<PlayLogsTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
